<!-- High-Density Header Dynamic Action Controls Toolbar Section -->
<div
  class="d-flex flex-wrap align-items-center justify-content-between gap-3 p-3 rounded-4 border shadow-sm bg-body-tertiary mt-3 mb-3">

  <!-- Left Side: Back Navigation Control Link Trigger -->
  <div>
    <button type="button"
      class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm text-body fw-semibold transition-base"
      (click)="goBack()">
      <i class="fa-solid fa-arrow-left font-xs"></i>
      <span>Back</span>
    </button>
  </div>

  <!-- Right Side: Segmented Filter Command Array -->
  <div class="d-flex align-items-center gap-2">
    <!-- Normal Claim Filter Button Trigger -->
    <button type="button"
      class="btn btn-sm px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base"
      [ngClass]="qrType() === 'claim' ? 'btn-primary' : 'btn-outline-primary text-body'" (click)="listQrCodes('claim')">
      <i class="fa-solid fa-circle-check font-xs"></i>
      <span>Normal Claims</span>
    </button>

    <!-- Illegal Claim Filter Button Trigger -->
    <button type="button"
      class="btn btn-sm px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base"
      [ngClass]="qrType() === 'illegal' ? 'btn-danger' : 'btn-outline-danger text-body'"
      (click)="listQrCodes('illegal')">
      <i class="fa-solid fa-triangle-exclamation font-xs"></i>
      <span>Illegal Claims</span>
    </button>
  </div>

</div>

<!-- Dynamic Status Context Alert Indicator Banner -->
@if (textalert()) {
<div class="alert alert-primary d-flex align-items-center gap-2 border-0 shadow-sm rounded-4 py-2.5 px-3 mb-3"
  role="alert">
  <i class="fa-solid fa-circle-info text-primary-emphasis fs-5 flex-shrink-0"></i>
  <div class="font-xs fw-semibold text-primary-emphasis tracking-wide">{{ textalert() }}</div>
</div>
}

<!-- High-Density Responsive Table Dynamic Scaling Window Frame Layer -->
<div class="card border shadow-sm rounded-4 overflow-hidden bg-body w-100 mb-4">
  <div class="table-responsive-container m-0">
    <table class="table table-hover align-middle mb-0 table-dense text-nowrap">

      <!-- Table Header Matrix Structures -->
      <thead class="table-light text-body-secondary font-monospace small text-uppercase tracking-wider border-bottom">
        <tr>
          <th scope="col" class="ps-4 py-3" width="70">#</th>
          <th scope="col" class="py-3" style="min-width: 160px;">Lucky Draw</th>
          <th scope="col" class="py-3" style="min-width: 120px;">Serial Number</th>
          <th scope="col" class="py-3" style="min-width: 160px;">QR Code</th>
          <th scope="col" class="py-3 text-end" width="100">Points</th>
          <th scope="col" class="py-3 text-center" width="100">Enabled</th>
          <th scope="col" class="py-3" style="min-width: 140px;">Customer Phone</th>
          <th scope="col" class="py-3" style="min-width: 155px;">Claim Time</th>
          <th scope="col" class="py-3 text-center" width="150">Illegal Check</th>
          <th scope="col" class="pe-4 py-3" width="160">Illegal Claim Type</th>
        </tr>
      </thead>

      <!-- Table Body Row Interpolations Logic Items Loops -->
      <tbody class="small text-body">
        @for (qr of qrcodes() | paginate : { itemsPerPage: pageSize(), currentPage: page() + 1, totalItems: allTotal()
        }; track qr.serialNumber; let i = $index) {
        <tr class="transition-base">
          <td class="ps-4 font-monospace fw-medium text-body-secondary">{{ qr.srNo }}</td>
          <td class="fw-bold text-body">{{ qr.luckyDrawName || '-' }}</td>
          <td class="font-monospace text-body-secondary">{{ qr.serialNumber }}</td>
          <td class="font-monospace text-body-secondary text-truncate max-w-200" [title]="qr.qrCode">{{ qr.qrCode }}
          </td>
          <td class="font-monospace text-end fw-bold text-success-emphasis pe-3">{{ qr.points | number }}</td>

          <!-- Structural Condition Status Badge elements validation maps -->
          <td class="text-center">
            @if (qr.enabled) {
            <span
              class="badge bg-success-subtle text-success-emphasis border border-success-subtle px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1.5 font-xs">
              <i class="fa-solid fa-circle-check"></i> Active
            </span>
            } @else {
            <span
              class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1.5 font-xs">
              <i class="fa-solid fa-circle-xmark"></i> Disabled
            </span>
            }
          </td>

          <td class="font-monospace fw-semibold text-body">{{ qr.claimCustomerLoginPhone || '-' }}</td>
          <td class="text-body-secondary font-monospace font-xs">{{ qr.claimTimeStamp ? (qr.claimTimeStamp | dateFormat)
            : 'Unclaimed' }}</td>

          <!-- Infraction Claim Intercept Badges Indicators -->
          <td class="text-center">
            @if (qr.hasIllegalClaims) {
            <span
              class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1.5 font-xs">
              <i class="fa-solid fa-circle-exclamation"></i> Critical Suspect
            </span>
            } @else {
            <span
              class="badge bg-info-subtle text-info-emphasis border border-info-subtle px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1.5 font-xs">
              <i class="fa-solid fa-shield-halved"></i> Clear Safe
            </span>
            }
          </td>

          <td class="pe-4 font-monospace text-uppercase fw-bold font-xs"
            [ngClass]="qr.illegalClaimType ? 'text-danger-emphasis' : 'text-body-secondary opacity-50'">
            {{ qr.illegalClaimType || 'None' }}
          </td>
        </tr>
        } @empty {
        <tr>
          <td colspan="10" class="text-center py-5 text-body-secondary">
            <i class="bi bi-inbox fs-2 d-block mb-2 opacity-50 text-body-secondary"></i>
            No Qr Code records matched your parameters.
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Navigation Pagination Footer -->
<div
  class="card-footer bg-transparent border-top py-3 px-4 transition-base d-flex flex-column flex-sm-row align-items-center justify-content-center">
  <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
    class="dashboard-pagination" (pageChange)="handlePageChange($event)">
  </pagination-controls>
</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}